'use strict';

let nextId = 1;

module.exports = (function() {
  class MarkerTooltip {
    static initClass() {
      this.prototype.id = null;
      this.prototype.marker = null;
      this.prototype.$hoverElement = null;
      this.prototype.$mapContainer = null;
      this.prototype.$tooltip = null;
      this.prototype.$marker = null;
    }

    constructor({ $hoverElement, marker, $mapContainer, $tooltip, $marker }) {
      this.show = this.show.bind(this);
      this.hide = this.hide.bind(this);
      this.$hoverElement = $hoverElement;
      this.marker = marker;
      this.$mapContainer = $mapContainer;
      this.$tooltip = $tooltip;
      this.$marker = $marker;
      this.id = nextId;
      nextId += 1;
      this.$hoverElement.hover(this.show, this.hide);
      this.$tooltip.find('.icon-x').click(() => {
        return this.$tooltip.removeClass('active');
      }); // Close all open Tooltips when a new Tooltip is shown.

      this.$mapContainer.on('tooltip-show', (evt, { id }) => {
        if (this.id !== id) {
          return this.hide();
        }
        return null;
      });
    }

    show() {
      this.$tooltip.addClass('active');
      this.updateLocation();
      return this.$mapContainer.trigger('tooltip-show', {
        id: this.id,
      });
    }

    hide() {
      return this.$tooltip.removeClass('active');
    }

    updateLocation() {
      let cssClass;
      const mapWidth = this.$mapContainer.innerWidth();
      const mapHeight = this.$mapContainer.innerHeight();
      const tooltipWidth = this.$tooltip.outerWidth();
      const tooltipHeight = this.$tooltip.outerHeight();
      const markerWidth = this.$marker.outerWidth();
      const markerHeight = this.$marker.outerHeight();
      const projection = this.marker.getProjection();

      if (projection == null) {
        return;
      }

      const markerPixelPosition = projection.fromLatLngToContainerPixel(
        this.marker.getPosition()
      );
      const margin = 10; // We first check where it would be possible to position the Tooltip,
      // and later we will choose the best one depending on which positions are possible.

      const position = {}; // We need 30 extra pixels to account for the "search as I move the map" div.

      if (markerPixelPosition.y > markerHeight + tooltipHeight + margin + 30) {
        position.top = true;
      }

      if (markerPixelPosition.y < mapHeight - (tooltipHeight + margin)) {
        position.bottom = true;
      }

      if (markerPixelPosition.x > markerWidth + tooltipWidth + margin) {
        position.left = true;
      }

      if (
        markerPixelPosition.x <
        mapWidth - (markerWidth + tooltipWidth + margin)
      ) {
        position.right = true;
      }

      if (
        markerPixelPosition.x > (markerWidth + tooltipWidth) / 2 + margin &&
        markerPixelPosition.x <
          mapWidth - ((markerWidth + tooltipWidth) / 2 + margin)
      ) {
        position.center = true;
      }

      const arrowHeight = 8; // Reset the Tooltip style.

      this.$tooltip.attr('style', '');
      this.$tooltip.removeClass(
        'top-center bottom-center top-left top-right bottom-left bottom-right'
      );

      if (position.top && position.center) {
        cssClass = 'top-center';
      } else if (position.top && position.left) {
        cssClass = 'top-left';
      } else if (position.top && position.right) {
        cssClass = 'top-right';
      } else if (position.bottom && position.right) {
        cssClass = 'bottom-right';
      } else if (position.bottom && position.left) {
        cssClass = 'bottom-left';
      } else if (position.bottom && position.center) {
        cssClass = 'bottom-center';
      } // We set a CSS class to position the arrow.

      this.$tooltip.addClass(cssClass); // We set inline styles to position the Tooltip.

      if (/^top-/.test(cssClass)) {
        const dotAdjustment = this.$marker.hasClass('show-dot')
          ? markerHeight - 10
          : 0;
        this.$tooltip.css(
          'top',
          `-${tooltipHeight + arrowHeight - dotAdjustment}px`
        );
      } else if (/^bottom-/.test(cssClass)) {
        if (this.$marker.hasClass('show-dot')) {
          this.$tooltip.css('top', `${markerHeight + arrowHeight + 5}px`);
        } else {
          const labelHeight = this.$marker.find('.marker-label').outerHeight();
          this.$tooltip.css('top', `${labelHeight + arrowHeight + 5}px`);
        }
      }

      if (/-center$/.test(cssClass)) {
        this.$tooltip.css('left', `-${tooltipWidth / 2 - markerWidth / 2}px`);
      } else if (/-left$/.test(cssClass)) {
        this.$tooltip.css('right', 0);
      } else if (/-right$/.test(cssClass)) {
        this.$tooltip.css('left', 0);
      }
    }
  }
  MarkerTooltip.initClass();
  return MarkerTooltip;
})();
